import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function getSalesAgentById(id, callback) {
	firebaseRef
		.ref('/kavtek_sales_agents/' + PROJECT_CODE.projectCode)
		.orderByChild('createrID')
		.equalTo(id)
		.once('value', (snapshot) => {
			try {
				console.log('Object Keys ' + snapshot.val());
				var objectKey = Object.keys(snapshot.val());
				console.log(
					'getSales agent snapshot',
					snapshot.val()[objectKey[0]]
				);
				var email = snapshot.val()[objectKey[0]].email;
				var fullName = snapshot.val()[objectKey[0]].name;

				var salesAgent = {
					email: email,
					fullName: fullName,
				};
				callback(salesAgent);
			} catch (err) {
				console.log('Err: ', err.message);
				callback([]);
			}
		});
}
